import { createContext } from 'react';

const CheckboxGroupContext = /*#__PURE__*/createContext({});

export { CheckboxGroupContext };
